import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData, GenericLinkComponent, IconComponent, IconModule, MediaComponent } from '@spartacus/storefront';
import { map } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';

@Component({
  selector: 'knbr-kn-br-brand-banner',
  templateUrl: './kn-br-brand-banner.component.html',
  styleUrl: './kn-br-brand-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MediaComponent, IconComponent]
})
export class KnBrBrandBannerComponent {
  activeSlideIndex: number = 0;
  slides: any[][] = [];
  items: any[] = [];
  itemsPerSlide: number = 3;


  constructor(private cmsService: CmsService,
    public component: CmsComponentData<any>,
    public knbrCommonService: KnBrCommonService,
    private cdr: ChangeDetectorRef) {

    this.component.data$.subscribe((data:any) => {
      let componentsList = data.brandBannersList?.trim().split(' ');
      let componentData: any
      this.knbrCommonService.getWhatsNewDataForMultipleComponents(componentsList).subscribe(combineddata => {
        componentData = [...combineddata];
        this.items = componentData
        this.updateItemsPerSlide();
        this.groupItems();
        this.cdr.detectChanges();
      })
    })
  }

  @HostListener('window:resize')
  onResize() {
    this.updateItemsPerSlide();
    this.groupItems();
  }

  updateItemsPerSlide(): void {
    const width = window.innerWidth;
    if (width <= 480) {
      this.itemsPerSlide = 1; // mobile
    } else if (width <= 768) {
      this.itemsPerSlide = 2; // tablet
    } else {
      this.itemsPerSlide = 4; // desktop
    }
  }

  groupItems() {
    this.slides = [];
    for (let i = 0; i < this.items.length; i += this.itemsPerSlide) {
      this.slides.push(this.items.slice(i, i + this.itemsPerSlide));
    }
  }


  isActiveSlide(index: number): boolean {
    return this.activeSlideIndex === index;
  }

  // Go to previous slide
  prevSlide(): void {
    if (!this.isPrevDisabled()) {
      this.activeSlideIndex--;
    }
  }

  // Go to next slide
  nextSlide(): void {
    if (!this.isNextDisabled()) {
      this.activeSlideIndex++;
    }
  }

  // Disable prev button if at first slide
  isPrevDisabled(): boolean {
    return this.activeSlideIndex === 0;
  }

  // Disable next button if at last slide
  isNextDisabled(): boolean {
    return this.activeSlideIndex === this.slides.length - 1;
  }
}
